import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router';

import { BroadcastViewerPage } from '../../../../../../../pages/broadcast-viewer';
import { CallPage } from '../../../../../../../pages/call';
import { ConferencesHistoryPage } from '../../../../../../../pages/conferences-history';
import { ConnectToMeetingByIdPage } from '../../../../../../../pages/connect-to-meeting-by-id';
import { CreateBroadcastPage } from '../../../../../../../pages/create-broadcast';
import { FeedbackPage } from '../../../../../../../pages/feedback';
import { CreateCallPage } from '../../../../../../../pages/main';
import { PlanCallPage } from '../../../../../../../pages/planning';
import { withErrorBoundary } from '../../../../../../helpers/hocs/with-error-boundary';
import { selectIsTeleMessengerConferencesHistory } from '../../../../../config/selectors';
import { selectIsTelemessengerExpEnabled } from '../../../../../flags/selectors';

interface PagesProps {
    isPlanningDisabled?: boolean;
    onCallOverlayHide?: () => void;
    withChat?: boolean;
}

const PagesComponent: FunctionComponent<PagesProps> = ({ isPlanningDisabled, onCallOverlayHide, withChat }) => {
    const isTelemessengerExpEnabled = useSelector(selectIsTelemessengerExpEnabled);
    const isTeleMessengerConferencesHistory = useSelector(selectIsTeleMessengerConferencesHistory);

    return (
        <Routes>
            <Route path="/" element={<CreateCallPage />} />
            <Route path="/connect-to-meeting-by-id" element={<ConnectToMeetingByIdPage />} />
            <Route path="/planning" element={isPlanningDisabled ? <Navigate to="/" /> : <PlanCallPage />} />
            <Route
                path="/broadcast-planning"
                element={isPlanningDisabled ? <Navigate to="/" /> : <PlanCallPage isBroadcast />}
            />
            <Route path="/create-broadcast" element={<CreateBroadcastPage />} />
            <Route path="/browser-auto-create" element={<CreateCallPage autoCreate />} />
            <Route path="/j/:id" element={<CallPage onOverlayHide={onCallOverlayHide} isChatAllowed={withChat} />} />
            {isTelemessengerExpEnabled && (
                <Route
                    path="/private-join/:id"
                    element={<CallPage onOverlayHide={onCallOverlayHide} isChatAllowed={withChat} />}
                />
            )}
            <Route path="/live/:id" element={<BroadcastViewerPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/conferences-history" element={<ConferencesHistoryPage />} />
            {isTeleMessengerConferencesHistory && (
                <Route path="/private-conferences-history" element={<ConferencesHistoryPage />}></Route>
            )}
        </Routes>
    );
};

export const Pages = withErrorBoundary(PagesComponent);
